import { render } from "./ModalBottomProfile.vue?vue&type=template&id=eff418c8&scoped=true&ts=true"
import script from "./ModalBottomProfile.vue?vue&type=script&lang=ts"
export * from "./ModalBottomProfile.vue?vue&type=script&lang=ts"

import "./ModalBottomProfile.vue?vue&type=style&index=0&id=eff418c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff418c8"]])

export default __exports__